import styled from 'styled-components';

export const NoData = styled.p`
    text-align: center;
    font-size: 170%;
    color: rgba(0, 0, 0, 0.325);
`;
